'use strict';

import {hasCities, replaceCityToAirport} from "../helpers/search";
import SearchRoutes from "../components/SearchRoutes";
import SearchSwitchTriple from "./SearchSwitchTriple";

export default class SearchRoutesForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            type: 'planes',
            airports: [],
            routesPlane: [{
                from: {},
                to: {},
                date: '',
                time: '',
                seats: 0,
            }],
        };
        
        this.handleChangeRoutes = this.handleChangeRoutes.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
    }

    componentDidMount() {
        this.init();
        listenEvent('search.set', data => {
            if (data && Array.isArray(data.routesPlane) && data.routesPlane.length > 0) {
                this.setState({ routesPlane: data.routesPlane });
            }
        });
    }

    init() {
        requestAction.initData().then(response => {
            this.setState({
                airports: response.airports,
            })
        })
    }

    handleChangeRoutes(routes) {
        let routesPlane = hasCities(routes) ? replaceCityToAirport(routes) : routes;
        this.setState({
            routesPlane: routesPlane,
        })
    }

    handleSearch() {
        const {routesPlane} = this.state;
        
        storageSet('reactSearchData', {routesPlane})
        ymReachGoal('search')
        window.location = (window.lang ? '/' + window.lang : '') + '/search'
    }

    getRoutes() {
        const {routesPlane} = this.state;
        return routesPlane;
    }

    render() {
        const {showSwitchTab} = this.props;
        const {containerClass, maxRoutes} = this.props;
        const {type, airports} = this.state;

        const routes = this.getRoutes();

        return <div>
            {showSwitchTab && <SearchSwitchTriple
                type={type}
            />}

            <SearchRoutes
                type={type}
                routes={routes}
                airports={airports}
                onlyAirports={true}
                maxAirports={8}
                onChangeRoutes={this.handleChangeRoutes}
                onSearch={this.handleSearch}
                requestMode={true}
                maxRoutes={maxRoutes || undefined}
                containerClass={containerClass || ''}
            />
        </div>
    }
};